module.exports = __webpack_public_path__ + "static/img/toddy.6ae5978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toddy.png
// module id = 5KcU
// module chunks = 1